import * as React from 'react';
import * as cx from 'classnames';

import SuperCritical from 'lib/supercritical';
import { tzmoment } from 'lib/tzmoment';
import { noDefault } from 'lib/eventWrappers';

import { DateTimePicker } from 'portcall/datetimepicker/view';
import { PCModal } from 'portcall/pcmodal/view';
import { EditMovementEndPopup } from './model';

export const EditMovementEndPopupView = SuperCritical(({ model: _model } : { model : () => EditMovementEndPopup | null }) => {
    const model = _model();
    return (
        <PCModal shown={() => !!model} className="editmovementendpopup" onBackDropClick={model?.OnClosePopup}>
            {model && <div className={cx("modal-content time-popup-body", {
                    'time-popup-show-mvmt-in'    : model.MovementType === 'in',
                    'time-popup-show-mvmt-out'   : model.MovementType === 'out',
                    'time-popup-show-mvmt-shift' : model.MovementType === 'shift'
                })}>
                <div className="time-popup-title">
                    <span className="time-popup-mvmt-in">New First Line</span>
                    <span className="time-popup-mvmt-out">{model.HasPilots() ? "New Pilot End (Disembark)" : "New Traffic End"}</span>
                    <span className="time-popup-mvmt-shift">New First Line</span>
                </div>
                <div>
                    <DateTimePicker value={model.DraftTime} localization={model.Localization} />
                </div>
                <div className="time-popup-option-list">
                    <div className="time-popup-option" onClick={e => model.KeepTimesLinked(true)}>
                        <span className={cx("time-popup-option-btn", {
                                'time-popup-option-btn-selected': model.KeepTimesLinked()
                            })}></span>
                        <div className="time-popup-option-descr">
                            <div>
                                <span>Change </span>
                                <span className="time-popup-mvmt-in">{model.HasPilots() ? "Pilot Time" : "Traffic"}</span>
                                <span className="time-popup-mvmt-out">Departure (Last Line)</span>
                                <span className="time-popup-mvmt-shift">Departure (Last Line)</span>
                                <span> to </span>
                                <span>{tzmoment(model.NewStartTimeIfLinked()).format('HH:mm')}.</span>
                            </div>
                            <div>
                                Maintain planned transit duration of {model.TransitDuration()} minutes.
                            </div>
                        </div>
                    </div>
                    <div className="time-popup-option" onClick={e => model.KeepTimesLinked(false)}>
                        <span className={cx("time-popup-option-btn", {
                                'time-popup-option-btn-selected': !model.KeepTimesLinked()
                            })}></span>
                        <div className="time-popup-option-descr">
                            <div>
                                <span>Keep </span>
                                <span className="time-popup-mvmt-in">{model.HasPilots() ? "Pilot Time" : "Traffic Time"}</span>
                                <span className="time-popup-mvmt-out">Departure (Last Line)</span>
                                <span className="time-popup-mvmt-shift">Departure (Last Line)</span>
                                <span> at </span>
                                <span>{tzmoment(model.StartTime()).format('HH:mm')}.</span>
                            </div>
                            <div>
                                Change planned transit duration to {model.NewTransitDurationIfUnlinked()} minutes.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="time-popup-errors">
                    {model.Errors().map(err => <div>{err.ErrorText}</div>)}
                </div>
                <div className="time-popup-actions">
                    <a href="" className="pc-cancel-link" onClick={noDefault(model.OnClosePopup)}>Cancel</a>
                    <button className="pc-button" onClick={model.SaveTimes}>Change</button>
                </div>
            </div>}
        </PCModal>
    );
});


// WEBPACK FOOTER //
// ./apps/portcall/editmovementendpopup/view.tsx